/**
 * 发表留言
 * @author Kody
 * @see http://api.umucdn.cn/project/232/interface/api/4307
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

interface IInput {
    to_umu_id: string;
    content: string;
}

export const postMessage = (param: IInput): Promise<IResponse<IProfileMessage>> => {
    return fetchData(Api.PROFILE_SAVE_MESSAGE, param, { silent: true });
};
